import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchPrivateChatOptions } from '../../api/fetchers/privateChat/fetcher';
import type { PrivateOptionsParams } from '../../api/fetchers/privateChat/types';

export const fetchPrivateChatOptionsAction = createAsyncThunk(
  'privateChatOptions/fetchPrivateChatOptions',
  (params: PrivateOptionsParams) => fetchPrivateChatOptions(params)
);
